export enum TaskDefinitionStatus {
  'READY' = 'READY',
  'NOT_READY' = 'NOT_READY',
}
export enum TaskDefinitionExecutionNamedStatus {
  'IN_PROGRESS' = 'IN_PROGRESS',
  'COMPLETED' = 'COMPLETED',
  'FAILED' = 'FAILED',
}

export type TaskDefinitionExecutionStatus = TaskDefinitionExecutionNamedStatus | null;

export type QCTaskDefinition = {
  id: string;
  name: string;
  description: string;
  status: TaskDefinitionStatus;
  executionStatus: TaskDefinitionExecutionStatus;
  lastExecutionDate: string;
  notMatchReasons: string[];
};

export type QCTaskDefinitionStatus = {
  id: string;
  executionStatus: TaskDefinitionExecutionStatus;
};
